<template>
  <div class="dashboard">
    <div class="section" v-loading="loading">
      <div class="section-content">
        <p class="title">T&C</p>
        <p>
          This Privacy Policy is part of our Flatknockers Private Limited’s Terms of Service. Therefore, 
          by accepting the Terms of Service and Privacy Policy on our log-in / registration page, you understand 
          the purpose and agree to share your personal information.Kindly read this Privacy Policy carefully before 
          using any Rummy’s services. We request you to refrain from registering if you do not wish to share your 
          information with app (hereinafter referred to as "Rummy" or "we" or "us" or "our") since the information 
          is mandatory and is requested at the time of registration. Please note that all non-optional fields are 
          required to be completed and your registration shall not be complete until information sought in the 
          non-optional fields is provided. Additional personal information may or may not be requested by Rummy for 
          permitting you access to some Cash Tables available on our platform.
        </p>
        <p>
          1. What is the Privacy Policy About? Rummy respects your privacy and assures you that any information 
          provided by you is protected and adheres to all Policies and the applicable laws. In order to get access 
          to the services offered on us (hereinafter referred to as the "App"), certain information needs to be 
          provided to us. This Policy outlines the procedure followed by Rummy to gather, use, store and manage 
          users' personal data. Collection of personal data is only for the purpose of verifying user accounts, 
          maintaining the accounts of users, completing transactions initiated by users and for analyzing user 
          behavior to fulfill the needed requirements. We aim to protect users data with transparency, accuracy 
          and confidentiality.
        </p>
        <p>
          2. What is included in personal data? Account password ( stored encrypted ) Financial Details such as 
          Bank Account, Credit Card, Debit Card or other payment details 2. Other Personal Information Name Date 
          of birth Telephone number Address Proof PAN Number The IP address of your computer, browser type and 
          language. The date and the time of your accessing the site. Active and current Location while Live on App. 
          The address that you may have used to link to our Website Your photograph for the purpose of testimonials 
          and other promotions. Any other information that is defined as "sensitive personal data or information" 
          in law. 3. Users’ Consent for the Above Consent to the use of Sensitive Personal Data and Other Personal 
          Information
          <br>
          All users of Rummy consent to the use of their Confidential Personal Data and Other Personal Information 
          by us for the purposes stated in this policy. Access to all information is restricted and only shared 
          with those who need to know such information in order to process, operate or resolve information on our 
          behalf.
          <br>
          Users are allowed to withdraw consent to the use of their Confidential Personal Data or Other Personal 
          Information. Withdrawal of consent to use all or any part of Sensitive Personal Data and Other Personal 
          Information may result in immediate withdrawal of any right provided to the user to use the services 
          provided by
          <br>
          Withdrawal of consent by users shall not restrict the right of Rummy to use Other Personal Information 
          for the analysis of user data, subject to the condition that the Other Personal Information used in 
          such analysis is not personally identifiable to any individual user.
          <br>
          Users’ providing photographs to Rummy for marketing purposes gives Rummy irrevocable rights to use them 
          and it is solely Rummy's discretion to delete or not use them any further.
          <br>
          Rummy may also use software applications for Website traffic analysis and to gather statistics, used 
          for advertising and for determining the efficacy and popularity of Rummy and other such purposes.
          <br>
        </p>
        <p>
          CONSENT TO THE USE OF COOKIES A cookie is a small text file that uniquely identifies your browser.
          <br>
          When you visit the Website, cookies may be left in your computer. The cookies assigned by the servers 
          of Rummy may be used to enhance your experience on the Website. Additionally, cookies may also be used 
          for authentication, game management, data analysis and security reasons.
          <br>
          Cookies may also be assigned by the advertisers of Rummy when you click on any of the advertisements, 
          which may be displayed on any website, in which case such cookies are controlled by these advertisers 
          and not Rummy.
          <br>
          CONSENT TO EMAIL COMMUNICATION Rummy may also access and store such information relating to your contacts 
          to send invitations and other promotions to them periodically.Exclude Location: Assam; Nagaland; Odisha; 
          Sikkim; Telangana
        </p>
        <p>
          We have the right to control the aaccess to our services at all times,in all States in India. 
          These terms of use shall be suitably modified to reflect changes in law/regulation/rule in any of the 
          states in India.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  }
  // mounted() {
  //   this.$http
  //     .all([
  //       this.$http.get("Honor/GetHonorAll"),
  //       this.$http.get("Enterprise/GetEnterpriseAll"),
  //       this.$http.get(`Team/GetTeamAll`),
  //       this.$http.get(`Course/GetCourseAll`)
  //     ])
  //     .then(
  //       this.$http.spread(
  //         (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
  //           this.honorList = responseHonor.data;
  //           this.partnerImg = responseEnterprise.data;
  //           this.teamItem = responseTeam.data;

  //           var groupCount = Math.ceil(responseCourse.data.length / 2);
  //           window.console.log(groupCount);
  //           for (let i = 0; i < groupCount; i++) {
  //             let img2 = [];
  //             for (let j = 0; j < 2; j++) {
  //               if (responseCourse.data.length - 1 >= i * 2 + j) {
  //                 img2.push(responseCourse.data[i * 2 + j]);
  //               }
  //             }
  //             this.courseList.push(img2);
  //           }
  //           window.console.log(this.courseList);
  //           this.loading = false;
  //         }
  //       )
  //     );
  // }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.dashboard {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 62%;
    margin-left: 19%;
    font-family: PingFangSC-Regular;
    font-size: 20px;
    letter-spacing: 0;
    font-weight: 400;

    &-content {

      .title {
        width: 100%;
        font-size: 24px;
        text-align: center;
        margin-top: 26px;
        margin-bottom: 20px;
      }
      .p2 {
        margin: 15px 0;
      }
      
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>